<template>
  <v-card raised>
    <v-card-text class="text-center pt-12">
      <v-row>
        <v-col cols="12" class="headline">
          <div :class="vocabularyColor ? `${vocabularyColor}--text` : ''">
            {{ vocabulary[this.languageSet.baseLanguage] }}
          </div>
          <v-btn
            v-if="!expand"
            class="mt-6"
            @click="expand=!expand">
            {{ $t('vocabulary.showTranslation') }}
          </v-btn>
          <div v-else class="mt-7">
            {{ vocabulary[this.languageSet.learningLanguage] }} {{ gender && `(${gender})` }}
          </div>
          <div :class="{hidden: !expand}" class="mt-7">
            <div v-if="vocabulary.vocal">
              {{ vocabulary.vocal }}
            </div>
          </div>
        </v-col>
        <v-col cols="12" v-if="lastSlide" class="pt-12">
          <div class="subtitle-1">
            {{ $t('vocabulary.testKnowledgeWithQuiz') }}
          </div>
          <v-btn
            class="mt-3 white--text"
            color="orange"
            @click="startQuiz">
            {{ $t('vocabulary.startQuiz') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions>
      <v-row class="justify-end">
        <v-col class="text-left">
          <v-btn
            :disabled="firstSlide"
            small
            text
            @click="$emit('prev:slide')">
            <v-icon left small class="mr-0" v-show="!firstSlide">
              keyboard_arrow_left
            </v-icon>
            {{ $t('app.previous') }}
          </v-btn>
        </v-col>
        <v-col class="text-right">
          <v-btn
            :disabled="lastSlide"
            small
            text
            @click="$emit('next:slide')">
            {{ lastSlide ? `${$t('app.end')}` : `${$t('app.next')}` }}
            <v-icon right small class="ml-0" v-show="!lastSlide">
              keyboard_arrow_right
            </v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { pathTo } from '@/plugins/router/helper';

export default {
  name: 'VocabularyContainer',
  props: {
    vocabulary: {
      type: Object,
      required: true,
    },
    firstSlide: {
      type: Boolean,
      required: true,
    },
    lastSlide: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    expand: false,
    pathTo,
  }),
  computed: {
    ...mapGetters('current', ['languageSet']),

    gender() {
      return this.vocabulary[`${this.languageSet.learningLanguage}_gender`];
    },
    vocabularyColor() {
      const { gender } = this;
      const colorMapper = {
        m: 'blue',
        f: 'red',
        n: 'green',
        pl: 'orange',
      };
      return colorMapper[gender];
    },
  },
  methods: {
    ...mapActions('current', ['setVocabularyScore', 'setQuizScore']),

    startQuiz() {
      this.setVocabularyScore(0);
      this.setQuizScore(0);
      this.$router.push(pathTo.quiz);
    },
  },
};
</script>

<style lang="scss" scoped>
.hidden {
  visibility: hidden;
}
</style>
